const LOADSAVEDJOBS = 'twineApp/savedJobs/LOADSAVEDJOBS';
const LOADSAVEDJOBS_SUCCESS = 'twineApp/savedJobs/LOADSAVEDJOBS_SUCCESS';
const LOADSAVEDJOBS_FAIL = 'twineApp/savedJobs/LOADSAVEDJOBS_FAIL';

const initialState = {
  loaded: false,
  loading: false,
  error: null,
  savedJobs: [],
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOADSAVEDJOBS:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
        savedJobs: [],
      };

    case LOADSAVEDJOBS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        savedJobs: action.result.collaborations
          ? action.result.collaborations
          : [],
        error: null,
      };

    case LOADSAVEDJOBS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        savedJobs: [],
        error: action.error,
      };

    default:
      return state;
  }
}

export const loadSavedJobs = () => {
  return {
    types: [LOADSAVEDJOBS, LOADSAVEDJOBS_SUCCESS, LOADSAVEDJOBS_FAIL],
    promise: (client) =>
      client.get('/users/savedJobs?include=user,user.avatars,user.covers'),
  };
};
